import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setTheme } from '../../actions/layoutActions';
import Contact from './Contact';


export class ContactContainer extends Component {
  static propTypes = {
    setTheme: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.setTheme('BLUE');
  }

  componentDidUpdate() {
    this.props.setTheme('BLUE');
  }

  render() {
    return (
      <Contact />
    );
  }
}


const mapDispatchToProps = {
  setTheme
};

export default connect(null, mapDispatchToProps)(ContactContainer);



// WEBPACK FOOTER //
// ./src/components/Contact/ContactContainer.js